import { clsx } from 'clsx';
import { FC } from 'react';
import { Icon, IconType } from 'atoms/Icon';
import styles from 'molecules/DeliveryStatus/DeliveryStatus.module.css';

export const TickIcon: FC<{
  color?: 'green' | 'yellow' | 'red';
  className?: string;
}> = ({ color = 'green', className }) => {
  return (
    <Icon
      type={IconType[color === 'red' ? 'close' : 'tick']}
      className={clsx(styles.tick, styles[color], className)}
    />
  );
};
